
import React, { useEffect, useState } from 'react';
import './componentsCss/ListCard.css';
import api from '../api';
import Loading from './Loading';
import Pusher from "pusher-js"
import CardProfessionalLoggedIn from './cards/CardProfessionalLoggedIn';
import ModalSchedulings from './modals/ModalSchedulings/ModalSchedulings';
function ListCardProfessionalsLoggedIn({ search, containerScrollStyle = {} }) {
    const [professionals, setProfessionals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [professional, setProfessional] = useState(null);
    const [showModalSchedulings, setShowModalSchedulings] = useState(false)

    const getProfessionals = (loading = true) => {
        setLoading(loading);
        api.get('/api/report/doctors/active/now').then((response) => {
            setProfessionals(response.data);
        }).catch((error) => {
            console.error('Error fetching agreements:', error);
        }).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        Pusher.logToConsole = true;

        const pusher = new Pusher("f1b255b7c74088ee23a6", {
            cluster: "mt1",
        });

        const channel = pusher.subscribe("update-active-professional-channel");
        channel.bind("update-active-professional-event", function (response) {
            getProfessionals(false)
        });

        return () => {
            pusher.unsubscribe("update-active-professional-event");
        };

    }, [])

    useEffect(() => {
        getProfessionals();
    }, [search]);

    return (
        <>
            <ModalSchedulings professional={professional} setShow={setShowModalSchedulings} show={showModalSchedulings} onHide={() => {
                setProfessional(null)
                setShowModalSchedulings(false)
            }} />

            <div style={containerScrollStyle} className='container-scroll'>
                <div className="row-subcontainer scroll-list-container">
                    {loading ? <Loading /> : (professionals.length ? professionals.map((professional, index) => {
                        return (
                            <CardProfessionalLoggedIn key={professional.id} onClick={() => {
                                setProfessional(professional)
                                setShowModalSchedulings(true)
                            }} index={index} professional={professional} />
                        );
                    }) : (<div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Profissionais Logados</h6></div>))}

                </div>
            </div>
        </>
    );
}

export default ListCardProfessionalsLoggedIn;
